module.exports = __webpack_public_path__ + "static/media/dairy.eafdf28a.jpg";